import { Injectable } from '@angular/core';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { CostCenter } from '@models';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class CostCenterService {
  public all$: Observable<CostCenter[]>;

  constructor(
    private readonly firestore: FirestoreService,
    private readonly tenantContext: TenantContextService,
  ) {
    this.all$ = this.tenantContext.tenantId$.pipe(
      switchMap(() =>
        this.firestore.listDocuments<CostCenter>(
          this.tenantContext.collections.ACCOUNTING_COST_CENTERS,
        ),
      ),
      shareReplay(1),
    );
  }

  getById(id: string): Observable<CostCenter> {
    return this.firestore.getDocument<CostCenter>(
      this.tenantContext.collections.ACCOUNTING_COST_CENTERS,
      id,
    );
  }

  async create(
    data: Omit<CostCenter, 'id' | 'createdAt' | 'updatedAt'>,
  ): Promise<string> {
    return this.firestore.create<CostCenter>(
      this.tenantContext.collections.ACCOUNTING_COST_CENTERS,
      data,
    );
  }

  async update(data: Partial<CostCenter> & { id: string }): Promise<void> {
    return this.firestore.update<CostCenter>(
      this.tenantContext.collections.ACCOUNTING_COST_CENTERS,
      data,
    );
  }

  async delete(id: string): Promise<void> {
    return this.firestore.delete(
      this.tenantContext.collections.ACCOUNTING_COST_CENTERS,
      id,
    );
  }
}
